// src/plugins/i18n.ts
import { createI18n } from 'vue-i18n'
import cs from '../locales/cs.json'
import en from '../locales/en.json'

// Sestavení objektu s překlady
const messages = {
  cs,
  en,
}

const i18n = createI18n({
  // Pokud používáte Composition API, nastavte legacy: false.
  legacy: false,
  locale: 'cs',          // výchozí jazyk
  fallbackLocale: 'en',  // záložní jazyk, pokud překlad v aktuálním jazyce neexistuje
  messages,
})

export default i18n
